export const SUBMIT_FEEDBACK = "SUBMIT_FEEDBACK"
export const SUBMIT_FEEDBACK_SUCCESS = "SUBMIT_FEEDBACK_SUCCESS"
export const SUBMIT_FEEDBACK_FAILED = "SUBMIT_FEEDBACK_FAILED"

export const SUBMIT_PRINTING = "SUBMIT_PRINTING"
export const SUBMIT_PRINTING_SUCCESS = "SUBMIT_PRINTING_SUCCESS"
export const SUBMIT_PRINTING_FAILED = "SUBMIT_PRINTING_FAILED"